import { dfsFn, sortRecords } from '../../../utils/index.js'

const leftMixin = {
  data() {
    return {
      columnsLeft: [
        {
          field: 'name',
          title: '名称',
          width: 250,
          tree: true, // 启用树形结构
          headerStyle: {
            textAlign: 'center' // 标题居中
          },
          style: {
            textAlign: 'left' // 内容左对齐（树形结构需要）
          }
        }
      ],
      // 树形结构假数据
      tableDataLeft: [],
      selectedRowsLeft: []
    }
  },
  methods: {
    async getLeftData() {
      this.loading = true
      const res = await this.$service.get('/bill-library/listAll', {
        code: '',
        level: '',
        name: '',
        parentId: '',
        type: this.tabActive
      })
      if (res?.code === 200) {
        this.tableDataLeft = sortRecords(res.data || [])
        this.$refs.leftTable.initialized(0, 1)
      }
      this.loading = false
    },
    async handleRowSelectLeft(rows) {
      if (this.loading) return
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      if (this.selectedRowsLeft?.id === obj.id) return
      this.loading = true
      this.selectedRowsLeft = obj
      await this.getData({ billLibraryId: obj.id })
      this.loading = false
    },
    // 单元格点击事件
    handleCellClick(args) {
      console.log('单元格点击事件:', args)
      const { col, row, value } = args
      this.$message({
        message: `点击了第${row + 1}行第${col + 1}列，值为: ${value}`,
        type: 'info'
      })
    }
  }
}

export { leftMixin }
